export class NPSDialogTrackingEvents {
  static ratingsClick = '[NPS Dialog] ratings click';
  static submitFeedbackClick = '[NPS Dialog] submit feedback click';
  static submitFeedbackSuccess = '[NPS Dialog] submit feedback success';
  static closeDialogClick = '[NPS Dialog] close dialog click';
  static scheduleCallClick = '[NPS Dialog]: Schedule Call Click';
  static closeDialogClickAfterSubmission = '[NPS Dialog] close dialog click after submission';
  static remindLaterClick = '[NPS Dialog] promo review remind later click';
  static promoReviewButtonClick = '[NPS Dialog] promo review button click';
}
